import { createContext } from 'react';

export const FacialRegistrationContext = createContext();
